<template>
  <v-toolbar flat dense color="rgba(0, 0, 0, 0.0)" class="colorToolBarSports">
    <div class="d-flex" style="width: 110px">
      <template v-if="type == 'live'">
        <v-icon color="primary" class="mr-3 live-ani">mdi-access-point</v-icon>
        <v-toolbar-title class="subtitle-1">{{ $t("live") }} </v-toolbar-title>
      </template>
      <template v-else>
        <v-icon color="accent" class="mr-3">mdi-star</v-icon>
        <v-toolbar-title class="subtitle-1">{{ $t("main") }} </v-toolbar-title>
      </template>
    </div>

    <v-divider vertical inset class="mx-4"></v-divider>

    <div class="d-flex" style="overflow-x: auto">
      <template v-for="sport in sportsNavTabs">
        <v-btn
          :key="sport.id_sport"
          v-show="idSport.includes(sport.id_sport)"
          v-on:click="sendIdSport(sport.id_sport)"
          class="mr-1 caption tab-sport"
          :input-value="activeTab(sport)"
          active-class=""
          rounded
          text
        >
          <img
            v-if="sport.icon_img"
            class="mb-0"
            width="24px"
            :src="sport.icon_img"
          />
          <iconSport v-else :idSport="sport.id_sport" />
          <span v-show="!$vuetify.breakpoint.smAndDown"
            >&nbsp; {{ sport.name_sport }}</span
          >
        </v-btn>
      </template>
    </div>
  </v-toolbar>
</template>

<script>
import iconSport from "@/components/icon-sport";
export default {
  name: "toolbar-tab-sports",
  components: {
    iconSport,
  },
  props: ["type", "data"],
  data: () => {
    return {
      sportsNavTabs: [],
      active: false,
    };
  },

  computed: {
    // recupera o nome do Sport na query
    sportName: function() {
      let sportName;
      if (this.type === "nextEvents") {
        sportName = this.$route.query.sport;
      }
      if (this.type === "live") {
        if (this.$route.params.event) {
          sportName = this.$route.query.sport;
        } else {
          sportName = this.$route.query.live;
        }
      }

      // Atualizar navTabs
      this.getSportsNavTabs();

      return sportName;
    },

    idSport: function() {
      return this.data;
    },
  },

  methods: {
    sendIdSport: function(id) {
      const type = this.type;
      const { name } = this.$route;
      const { sport, live } = this.$route.query;

      if (type == "nextEvents") {
        this.$emit("filterBySports", { type, id });
        this.$router.push({
          query: {
            sport: this.$store.getters.getNameSportById(id),
            live: live,
          },
        });
      } else if (this.type === "live") {
        const sportsRoutes = [
          "DepositSuccessSports",
          "RegisterSuccessSports",
          "Sports",
        ];

        if (sportsRoutes.includes(name)) {
          this.$router.push({
            query: {
              sport,
              live: this.$store.getters.getNameSportById(id),
            },
          });
        }

        if (name == "eventsLive" || name == "live") {
          this.$router.push({
            name: "live",
            path: "/live",
            query: {
              live: this.$store.getters.getNameSportById(id),
            },
          });
        }
      }
    },

    activeTab: function(sport) {
      if (this.type == "nextEvents") {
        return sport.id_sport == this.$invertSports[this.sportName]
          ? true
          : false;
      } else {
        return sport.id_sport == this.$invertSports[this.sportName]
          ? true
          : false;
      }
    },

    async getSportsNavTabs() {
      this.sportsNavTabs = await this.$handlerIconsImgSports(
        this.$store.state.sports
      );
    },
  },

  mounted() {
    this.getSportsNavTabs();
  },
};
</script>

<style>
.tab-sport.v-btn--active {
  pointer-events: none;
}
</style>
